// extracted by mini-css-extract-plugin
export var brand = "_9k-9";
export var compact = "_9k-6";
export var extraSmall = "_9k-7";
export var icon = "_9k-0";
export var large = "_9k-4";
export var light = "_9k-1";
export var medium = "_9k-5";
export var outline = "_9k-b";
export var primaryDark = "_9k-a";
export var primaryLight = "_9k-8";
export var primaryModern = "_9k-c";
export var success = "_9k-2";
export var successSolid = "_9k-3";